const CONTENT_1 = `
<h4>Projektbeschreibung</h4>
<br/>
<p>Classic Company ist eine renommierte Plattform für den An- und Verkauf von Antiquitäten, Oldtimern und Sammlerstücken. Unser Projektziel war es, eine ansprechende und benutzerfreundliche Website zu entwickeln, die Sammler und Händler miteinander verbindet. Dabei haben wir ein modernes Design mit klassischen Elementen kombiniert, um die Einzigartigkeit und den Wert der angebotenen Stücke zu unterstreichen.</p>

<br/>
<br/>

<h4>Unsere Arbeitsweise</h4>
<br/>
<p>Wir haben eng mit dem Team von Classic Company zusammengearbeitet, um ihre Vision zu realisieren. Durch den Einsatz neuester Web-Technologien konnten wir eine Plattform schaffen, die nicht nur optisch ansprechend ist, sondern auch ein reibungsloses Nutzererlebnis bietet.</p>
<br/>
<ul>
    <li>Entwicklung einer intuitiven Benutzeroberfläche</li>
    <li>Integration von sicheren Zahlungs- und Versandlösungen</li>
    <li>Suchmaschinenoptimierung zur Steigerung der Sichtbarkeit</li>
</ul>

<br/>
<br/>
<h4>Ergebnisse</h4>
<br/>
<p>Das Ergebnis war eine deutliche Steigerung der Nutzerzahlen und der Verkaufsabschlüsse auf der Plattform. Die Kombination aus durchdachtem Design und technologischer Raffinesse hat Classic Company geholfen, sich als führender Marktplatz in Europa zu etablieren.</p>
<ul>
    <li>Steigerung der Nutzerzahlen</li>
    <li>Erhöhung der Verkaufsabschlüsse</li>
    <li>Stärkung der Markenbekanntheit</li>
</ul>
`;

const CONTENT_2 = `
<h4>Projektbeschreibung</h4>
<br/>
<p>Eiscafe Rimini, ein beliebtes Eiscafé in der Region, wollte seine Online-Präsenz stärken und ein digitales Erlebnis bieten, das der Qualität ihrer Produkte gerecht wird. Unser Ziel war es, eine Website zu entwickeln, die sowohl informativ als auch ansprechend ist und die Atmosphäre des Cafés widerspiegelt.</p>

<br/>
<br/>

<h4>Unsere Arbeitsweise</h4>
<br/>
<p>Für das Eiscafe Rimini haben wir eine benutzerfreundliche Website entwickelt, die es den Kunden ermöglicht, das Angebot des Cafés online zu erkunden und Bestellungen bequem von zu Hause aus aufzugeben.</p>
<br/>
<ul>
    <li>Einbindung von hochauflösenden Bildern, die die Qualität der Produkte hervorheben</li>
    <li>Entwicklung eines einfachen und effizienten Online-Bestellsystems</li>
    <li>Optimierung der Website für mobile Geräte</li>
</ul>

<br/>
<br/>
<h4>Ergebnisse</h4>
<br/>
<p>Nach dem Launch der neuen Website verzeichnete das Eiscafe Rimini eine Zunahme der Online-Bestellungen und eine größere Kundenbindung. Die Website hat dazu beigetragen, das Café auch über die lokale Kundschaft hinaus bekannt zu machen.</p>
<ul>
    <li>Zunahme der Online-Bestellungen</li>
    <li>Erhöhung der Kundenbindung</li>
    <li>Erweiterung der Bekanntheit über die lokale Kundschaft hinaus</li>
</ul>
`;

const galleryImgs1 = [
  '/assets/images/z36/casestudy/classic-company/classic-company-cover.jpg',
  '/assets/images/z36/casestudy/classic-company/instagram.jpg',
  '/assets/images/z36/casestudy/classic-company/branding.jpg',
  '/assets/images/z36/casestudy/classic-company/Main-C01.jpg',
  '/assets/images/z36/casestudy/classic-company/Product-Page.jpg',
];

const galleryImgs2 = [
  '/assets/images/z36/casestudy/eiscaferimini/kunde-rimini-webshop.jpg',
  '/assets/images/z36/casestudy/eiscaferimini/kunde-rimini-pages.png',
  '/assets/images/z36/casestudy/eiscaferimini/eiscaferimini.jpg',
];

const _caseStudies = [
  {
    id: 'classic-company',
    content: CONTENT_1,
    title: 'Classic Company',
    category: 'Branding & Web Development',
    createdAt: '17 Aug 2024',
    website: 'https://classic-company.de/',
    description: 'Von Alt zu Gold: Ein Blick hinter die Kulissen unserer Branding-Arbeit für einen Marktplatz von Antiquitäten und Oldtimer! Entdecken Sie, wie wir als kreative Agentur dieses Unterfangen gemeistert haben und wie unser Kunde nun auf dem besten Weg ist, zur Top-Adresse in Europa für Raritäten zu werden.',
    heroUrl: '/assets/images/z36/casestudy/classic-company/classic-company-cover.jpg',
    coverUrl: '/assets/images/z36/casestudy/classic-company/classic-company.jpg',
    how_we_work: 'Wir haben eng mit dem Team von Classic Company zusammengearbeitet, um ihre Vision zu realisieren.',
    results: 'Das Ergebnis war eine deutliche Steigerung der Nutzerzahlen und der Verkaufsabschlüsse auf der Plattform.',
    galleryImgs: galleryImgs1,
  },
  {
    id: 'eiscaferimini',
    content: CONTENT_2,
    title: 'Eiscafe Rimini',
    category: 'Web Development',
    createdAt: '05 Sep 2023',
    website: 'https://eiscaferimini.de/',
    description: 'Entdecken Sie, wie wir mit modernster Technologie und kreativen Designs ein hochmodernes Web-Portal für Eis Cafe Rimini entwickelt haben.',
    heroUrl: '/assets/images/z36/casestudy/eiscaferimini/kunde-rimini-webshop.jpg',
    coverUrl: '/assets/images/z36/casestudy/eiscaferimini/eiscaferimini.jpg',
    how_we_work: 'Wir haben eine benutzerfreundliche Website entwickelt, die es den Kunden ermöglicht, das Angebot des Cafés online zu erkunden und Bestellungen bequem von zu Hause aus aufzugeben.',
    results: 'Nach dem Launch der neuen Website verzeichnete das Eiscafe Rimini eine Zunahme der Online-Bestellungen und eine größere Kundenbindung.',
    galleryImgs: galleryImgs2,
  } 
];

export default _caseStudies;
